import React from 'react';
import {
  MediaFile,
  MEDIA_FILES_DOCUMENT,
} from '../../../../data/models/LibraryFile/MediaFile';
import {inject, observer} from 'mobx-react';
import MyLibraryModalStore from '../../../../modules/MyLibraryModal/store/MyLibraryModalStore';
import LibraryFilesInput from '../../../../uiToolkit/Inputs/LibraryFilesInput';
import TooltipQuestionMark from '../../../../uiToolkit/TooltipQuestionMark';
import {generateAiAssistantText} from '../generateAiAssisntantText';

interface Props {
  myLibraryModalStore?: MyLibraryModalStore;
  sourceFiles?: MediaFile[];
  onFilesSelected: (files: MediaFile[]) => void;
  disabled?: boolean;
}

const SpecialBrowse: React.FC<Props> = ({
  myLibraryModalStore,
  sourceFiles,
  onFilesSelected,
  disabled,
}) => {
  const openMediaLibrary = () => {
    myLibraryModalStore?.showLibrary(
      MEDIA_FILES_DOCUMENT,
      files => onFilesSelected(files),
      true,
      sourceFiles || [],
    );
  };

  return (
    <div className="SepcialBrowse">
      <div className="LibraryFilesButtonContainer">
        <span>{generateAiAssistantText.knowledgeBaseTitle}</span>
        <span className="MandatoryIndicator">*</span>
        <TooltipQuestionMark
          text={generateAiAssistantText.knowledgeBaseTooltip}
        />
      </div>
      <LibraryFilesInput
        onBrowse={openMediaLibrary}
        files={sourceFiles || []}
        onRemoveFile={(files?: MediaFile[]) =>
          onFilesSelected(files ? files : [])
        }
        disabled={disabled}
      />
    </div>
  );
};

export default inject('myLibraryModalStore')(observer(SpecialBrowse));
